import {
  NotificationFrequencyResponse,
  UpdateUserEmailSerializer,
  UpdateUserPasswordSerializer,
  UserProviderProfile,
} from "../../../recoil/types";
import { fetchOrLogout } from "../../../utils/helpers";
import { getBaseUrl } from "../../../utils/requestUtils";

export interface UpdateProfileRequestType {
  first_name: string;
  last_name: string;
}

export const updateProfileInitialValues: UpdateProfileRequestType = {
  first_name: "",
  last_name: "",
};

export const GetProfile = async (
  token: string,
  setLoggedOut: (inactivity: boolean) => void,
): Promise<Response> => {
  const baseUrl = await getBaseUrl();
  return fetchOrLogout(
    `${baseUrl}/api/v1/provider_portal/profile`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
    setLoggedOut,
  );
};

export const RefreshProviderProfile = async (
  token: string,
  setProviderProfile: (profile: UserProviderProfile) => void,
  setLoggedOut: (inactivity: boolean) => void,
): Promise<void> => {
  try {
    const profileResponse = await GetProfile(token, setLoggedOut);
    if (profileResponse?.ok) {
      setProviderProfile((await profileResponse.json()) as UserProviderProfile);
    }
  } catch {
    // Profile is not required to complete login.
  }
};

export const UpdateProfile = async (
  token: string,
  updates: UpdateProfileRequestType,
  setLoggedOut: (inactivity: boolean) => void,
): Promise<Response> => {
  const baseUrl = await getBaseUrl();
  return fetchOrLogout(
    `${baseUrl}/api/v1/provider_portal/profile`,
    {
      method: "POST",
      body: JSON.stringify(updates),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
    setLoggedOut,
  );
};

export const UpdateEmailRequest = async (
  newEmail: UpdateUserEmailSerializer,
  setLoggedOut: (inactivity: boolean) => void,
  access_token?: string,
): Promise<Response> => {
  const baseUrl = await getBaseUrl();
  return fetchOrLogout(
    `${baseUrl}/api/v1/account/email`,
    {
      method: "POST",
      body: JSON.stringify(newEmail),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access_token}`,
      },
    },
    setLoggedOut,
  );
};

export const UpdatePasswordRequest = async (
  passwordInfo: UpdateUserPasswordSerializer,
  setLoggedOut: (inactivity: boolean) => void,
  access_token?: string,
): Promise<Response> => {
  const baseUrl = await getBaseUrl();
  return fetchOrLogout(
    `${baseUrl}/api/v1/account/password`,
    {
      method: "POST",
      body: JSON.stringify(passwordInfo),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access_token}`,
      },
    },
    setLoggedOut,
  );
};

export const GetEmailNotifications = async (
  token: string,
  setLoggedOut: (inactivity: boolean) => void,
): Promise<Response> => {
  const baseUrl = await getBaseUrl();
  return fetchOrLogout(
    `${baseUrl}/api/v1/provider_portal/notification_center`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
    setLoggedOut,
  );
};

export const PostEmailNotifications = async (
  token: string,
  payload: NotificationFrequencyResponse,
  setLoggedOut: (inactivity: boolean) => void,
): Promise<Response> => {
  const baseUrl = await getBaseUrl();
  return fetchOrLogout(
    `${baseUrl}/api/v1/provider_portal/notification_center`,
    {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
    setLoggedOut,
  );
};
